module.exports = require('react/lib/ReactFragment').create;


/*****************
 ** WEBPACK FOOTER
 ** /Users/gaearon/p/react-devtools/~/react-addons-create-fragment/index.js
 ** module id = 215
 ** module chunks = 0
 **/